import { render } from "./reservation.vue?vue&type=template&id=bc2e4236&scoped=true"
import script from "./reservation.vue?vue&type=script&lang=js"
export * from "./reservation.vue?vue&type=script&lang=js"

import "./reservation.vue?vue&type=style&index=0&id=bc2e4236&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc2e4236"]])

export default __exports__